import { Routes, Route, Navigate } from "react-router-dom";
import ReportPage from "../pages/Reports/ReportPage";
import MaterialsReport from "../pages/Reports/MaterialsReport/MaterialsReport";
import OrdersReport from "../pages/Reports/OrdersReport/OrdersReport";
import CashReport from "../pages/Reports/CashReport/CashReport";
import MovimentReport from "../pages/Reports/MovimentReport/MovimentReport";
import CustomersReport from "../pages/Reports/CustomersReport/CustomersReport";

/**
 * As rotas de Relatórios. Todas SÓ LEITURA (§5.1) — nenhuma delas leva a uma
 * tela que altera saldo, preço ou venda.
 *
 * `cash`, `moviment` e `customers` são novas. `customers` estava prometida no
 * menu desde sempre e caía no `Navigate to="../"` — clicava e voltava para o
 * índice, sem dizer nada. Agora existe, e explica o próprio bloqueio.
 *
 * Canais e Fiscal ficam FORA de propósito (PLANO §9): item de menu que abre
 * tela vazia é pior que item de menu ausente.
 */
const ReportRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ReportPage />} />
      <Route path="orders" element={<OrdersReport />} />
      <Route path="cash" element={<CashReport />} />
      <Route path="customers" element={<CustomersReport />} />
      <Route path="materials" element={<MaterialsReport />} />
      <Route path="moviment" element={<MovimentReport />} />
      <Route path="*" element={<Navigate to="../" />} />
    </Routes>
  );
};

export default ReportRoutes;
